module.exports = __webpack_public_path__ + "img/54.04715a1c.jpg";